import { forwardRef, useContext, useEffect, useImperativeHandle } from "react";
import { DataTable } from "primereact/datatable";
import { useAPIGetProduct } from "../api/api-get-product-selector";
import { Column } from "primereact/column";
import ProductSelectorFilter from "./product-selector-filter";
import { Paginator } from "primereact/paginator";
import { genTemplateBodyNumber, genTemplateBodyText } from "../../../../components/utils/TableTemplateBodyGenerator";

const ProductSelectorList = forwardRef((props, ref) => {
  const { onConfirm, onHide, visible, title, additionalFilter, multiple } =
    props;

  const {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
    listSelected,
    setListSelected,
  } = useAPIGetProduct({ additionalFilter });

  useImperativeHandle(ref, () => ({
    handleOnUpdateViewRow: (row) => {
      handleOnUpdateViewRow(row);
    },
    handleOnDeleteViewRow: (row) => {
      handleOnDeleteViewRow(row);
    },
    getSelectedData: () => {
      return listSelected;
    },
  }));

  // use effect section

  useEffect(() => {
    if (visible) {
      setListSelected([]);
      fetchListData({ page: paging.page, take: paging.take });
    }
  }, [visible]);
  //  custom ui section

  // PART_TEMPLATE_BODY_GENERATOR
  const CodeBodyTemplate = (row) => genTemplateBodyText({ row, field: 'code' });
  const NameBodyTemplate = (row) => genTemplateBodyText({ row, field: 'name' });
  const PriceBodyTemplate = (row) => genTemplateBodyNumber({ row, field: 'price' });
  const DescriptionBodyTemplate = (row) => genTemplateBodyText({ row, field: 'description' });
  const IsPackageBodyTemplate = (row) => (
    <span className={row.is_package ? "font-bold text-green-600" : "text-slate-500"}>
      {row.is_package ? "YES" : "NO"}
    </span>
  );

  return (
    <div className="col-start-start w-full gap-4">
      {/* filter section */}
      <ProductSelectorFilter
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        onClickRefresh={handleOnClickRefresh}
      />

      {/* table section */}
      <div className="col-start-start w-full gap-2">
        <DataTable
          dataKey="id"
          onSelectionChange={(e) => setListSelected(e.value)}
          selection={listSelected}
          className="w-100"
          loading={loading}
          showGridlines
          stripedRows
          value={listData}
        >
          <Column
            key=""
            selectionMode={multiple ? "multiple" : "single"}
            headerStyle={{ width: "3rem" }}
          ></Column>

          <Column
            field="no"
            header="#"
            align="center"
            className="text-center"
            headerClassName="w-[4rem]"
            alignHeader={"center"}
          />
          {/*PART_TEMPLATE_BODY_RENDER*/}
          <Column header='Name' field="name" body={NameBodyTemplate} />
          <Column header='Package?' field="is_package" body={IsPackageBodyTemplate} align="center" style={{ width: '6rem' }} />
          <Column header='Price' field="price" body={PriceBodyTemplate} />
          <Column header='Description' field="description" body={DescriptionBodyTemplate} />
        </DataTable>
        <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          template={{ layout: "PrevPageLink CurrentPageReport NextPageLink" }}
          onPageChange={handleOnPage}
          pt={{
            prevPageButton: {
              className:
                "bg-red-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
            },
            nextPageButton: {
              className:
                "bg-red-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
            },
            current: {
              className: "bg-red-100 !m-0 max-h-[22px] text-sm",
            },
          }}
        />
      </div>
    </div>
  );
});

export default ProductSelectorList;
